
export default {
  props: {
    buttons: {
      type: [Object, Array],
      required: true,
    },
  },
  data () {
    return {
    };
  },
  methods: {
    getButtonLink (button) {
      return button.external_link
        ? button.url
        : button.page?.post_slug;
    },
  },
};
